import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=ceaaf028&scoped=true&"
import script from "./Incidents.vue?vue&type=script&lang=js&"
export * from "./Incidents.vue?vue&type=script&lang=js&"
import style0 from "./Incidents.vue?vue&type=style&index=0&id=ceaaf028&lang=scss&scoped=true&"
import style1 from "./Incidents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaaf028",
  null
  
)

export default component.exports